document.addEventListener('DOMContentLoaded', function () {
  if (typeof CircleType !== 'function') {
    console.error('CircleType not loaded');
    return;
  }

  document.querySelectorAll('.pb-curved-text').forEach(function (el) {
    const desktopRadius = parseInt(el.dataset.radiusDesktop) || 120;
    const mobileRadius  = parseInt(el.dataset.radiusMobile) || desktopRadius;

    const radius = window.innerWidth <= 768 ? mobileRadius : desktopRadius;

    new CircleType(el).radius(radius);
  });

  const cards = document.querySelectorAll(".flip-card");

  cards.forEach(card => {
    card.addEventListener("click", () => {
      card.classList.toggle("is-flipped");
    });
  });
});